class SizeGuideDrawer extends Theme.Drawer {
  connectedCallback() {
    super.connectedCallback();

    this.addDirectEvent("sizeguidedrawer:click", document, () => {
      this.show();
    });

    requestAnimationFrame(() => {
      this.initVideoObserver();
    });
  }

  hide() {
    super.hide();
    this.pauseAllVideos();
  }

  initVideoObserver() {
    const root = this.querySelector('.size-guide-content');
    const videos = this.querySelectorAll('component-video');

    if (!root || !videos.length) {
      return;
    }

    const playThreshold = 0.8;

    this.videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const videoComponent = entry.target;

        if (entry.intersectionRatio >= playThreshold && this.classList.contains('state--active')) {
          if (!videoComponent.hasAttribute('user-paused')) {
            videoComponent.play();
          }
        } else {
          videoComponent.pause();
          videoComponent.removeAttribute('user-paused');
        }
      });
    }, {
      root: root,
      threshold: [0, playThreshold]
    });

    videos.forEach((videoComponent) => {
      this.videoObserver.observe(videoComponent);
    });
  }

  pauseAllVideos() {
    const videos = this.querySelectorAll('component-video');
    videos.forEach((videoComponent) => {
      videoComponent.removeAttribute('user-paused');
      videoComponent.pause();
    });
  }

  disconnectedCallback() {

    super.disconnectedCallback();
    if (this.videoObserver) {
      this.videoObserver.disconnect();
    }
  }
}

customElements.define("size-guide-drawer", SizeGuideDrawer);